export default ({ user, size = 'md' }) => {
  let wh;
  switch (size) {
    case 'xs':
      wh = '10';
      break;
    case 'sm':
      wh = '10';
      break;
    case 'md':
      wh = '12';
      break;
    case 'lg':
      wh = '16';
      break;
  }

  return (
    <div
      className={`w-${wh} h-${wh} border border-gray-200 overflow-hidden bg-center bg-cover rounded-full`}
      style={{ backgroundImage: `url('${user.image}')` }}
    ></div>
  );
};
